/* État de connexion Supabase (session en localStorage, cf. sections/onwa-account.liquid).
   Met à jour le bouton « Connexion » du header : « Mon compte » (ou le pseudo) quand une session existe. */
(function () {
  function read() {
    try {
      var s = JSON.parse(localStorage.getItem('onwa:sb-session'));
      return s && s.refresh_token ? s : null;
    } catch (e) { return null; }
  }
  function name() {
    try { return localStorage.getItem('onwa:sb-name') || ''; } catch (e) { return ''; }
  }
  function apply() {
    var logged = !!read();
    document.documentElement.toggleAttribute('data-onwa-logged', logged);
    document.querySelectorAll('[data-onwa-account-link]').forEach(function (a) {
      var loggedInLabel = a.dataset.labelLoggedIn || 'Mon compte';
      var loggedOutLabel = a.dataset.labelLoggedOut || 'Connexion';
      a.textContent = logged ? (name() || loggedInLabel) : loggedOutLabel;
      a.title = logged ? loggedInLabel : '';
    });
  }
  window.addEventListener('storage', apply);
  window.addEventListener('onwa:account-changed', apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
